import EyeSVG from '../../assets/svg/eye.svg';
export default EyeSVG;
